import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlantMasterComponent } from './plantMaster.component';
// import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';

import { BrowserModule } from '@angular/platform-browser';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    // NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,

    BrowserModule,
    DataTablesModule,
    NgxSpinnerModule
  ],
  declarations: [PlantMasterComponent]
})
export class PlantMasterModule { }
